export const HelpSidebarSegment = props => {

    const { segment } = props;

    return (
        <section>

            <h6 className={'text-strong fw-semibold mb-1'}>
                {segment.title}
            </h6>

            <div className={'text-muted small'}>
                {segment.body}
            </div>

        </section>
    );

};